import { defineRecipe } from '@chakra-ui/react';

/**
 * Digitane AI Button Recipe
 * Custom button variants for child-friendly design
 */

export const buttonRecipe = defineRecipe({
  className: 'button',
  base: {
    borderRadius: 'md',
    fontWeight: 'semibold',
    transition: 'all 0.2s',
    cursor: 'pointer',
    _disabled: {
      opacity: 0.6,
      cursor: 'not-allowed',
      bg: 'gray.200',
    },
  },
  variants: {
    variant: {
      // Primary variant: Main CTA button
      primary: {
        bg: 'primary',
        color: 'white',
        _hover: {
          bg: 'primaryHover',
          transform: 'scale(1.05)',
          boxShadow: 'primaryGlow',
        },
        _active: {
          transform: 'scale(0.98)',
          boxShadow: 'sm',
        },
      },

      // Secondary variant: Cancel/secondary actions
      secondary: {
        bg: 'gray.100',
        color: 'gray.700',
        _hover: {
          bg: 'primaryLight',
          color: 'primary',
        },
        _active: {
          transform: 'scale(0.98)',
        },
      },

      // Error variant: Destructive actions
      error: {
        bg: 'semantics.errorDark',
        color: 'white',
        _hover: {
          boxShadow: 'errorGlow',
          transform: 'translateY(-1px)',
        },
        _active: {
          transform: 'translateY(0)',
        },
      },

      // Cancel variant: Dismissive actions
      cancel: {
        bg: 'gray.100',
        color: 'gray.700',
        _hover: {
          bg: 'gray.200',
        },
        _active: {
          transform: 'scale(0.98)',
        },
      },

      // Gradient Primary variant: Special CTAs
      'gradient-primary': {
        bg: 'gradientPrimary',
        color: 'white',
        _hover: {
          opacity: 0.9,
          transform: 'scale(1.05)',
        },
        _active: {
          transform: 'scale(0.98)',
        },
      },

      // Gradient Image variant: Image generation button
      'gradient-image': {
        bg: 'gradientPrimary',
        border: '2px solid',
        borderColor: 'whiteAlpha.500',
        color: 'white',
        _hover: {
          opacity: 0.9,
          borderColor: 'whiteAlpha.700',
          transform: 'translateY(-2px)',
        },
        _active: {
          transform: 'translateY(0)',
        },
      },
    },
    size: {
      sm: {
        px: 3,
        py: 1.5,
        fontSize: 'sm',
        minH: 8,
      },
      md: {
        px: 4,
        py: 2,
        fontSize: 'md',
        minH: 10,
      },
      lg: {
        px: 5,
        py: 2.5,
        fontSize: 'lg',
        minH: 11,
      },
    },
  },
  defaultVariants: {
    variant: 'primary',
    size: 'md',
  },
});
